module.exports = __webpack_public_path__ + "static/media/logo.7333473e.png";